import { useState } from "react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Button } from "@ui/button";

import { SadieSimulatorTool, SadieSimulatorToolInput } from "@/types";

// One tool Sadie had, with what the model reads about it. What it takes is
// tucked away until opened.
export const SadieSimulatorToolItem = ({
  tool,
}: {
  tool: SadieSimulatorTool;
}) => {
  /* React Hooks */
  const [isExpanded, setIsExpanded] = useState(false);

  /* Render */
  return (
    <Column className="gap-0.5 rounded-md border border-slate-200 bg-white p-2">
      <Text className="font-mono text-xs text-slate-700">{tool.name}</Text>
      <Text className="whitespace-pre-wrap text-xs font-normal text-slate-500">
        {tool.description}
      </Text>
      {tool.inputs.length > 0 ? (
        <Button
          className="h-auto self-start p-0 text-xs text-slate-500"
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
          variant="link"
        >
          {isExpanded
            ? "Hide what it takes"
            : `What it takes (${String(tool.inputs.length)})`}
        </Button>
      ) : null}
      {isExpanded
        ? tool.inputs.map((input) => (
            <ToolInputLine input={input} key={input.name} />
          ))
        : null}
    </Column>
  );
};

const ToolInputLine = ({ input }: { input: SadieSimulatorToolInput }) => (
  <Row className="items-baseline gap-1">
    <Text className="shrink-0 font-mono text-xs text-slate-700">
      {input.name}
    </Text>
    <Text className="text-xs font-normal text-slate-500">
      {`${input.type}, ${input.required ? "required" : "optional"}${input.description ? `. ${input.description}` : ""}`}
    </Text>
  </Row>
);
